import React from "react";

const Resources = () => {
  return (
    <div className="container my-5">
      <div className="heading">
        Computational Resources
      </div>
      <hr />
      <div className="row">
        <div className="col-sm-6 textAlign">
          <div className="text-bold mb-2 mt-4">Buddha</div>
          <p>1 Master node with 2 x Intel® Xeon® Gold 6248 Processor, (32M Cache, 2.50
GHz), 20C/40T</p>
          <p>
          4 Compute nodes with 2 x Intel® Xeon® Gold 6342 Processor, (36M Cache,
2.80 GHz), 24C/48T
          </p>

          <div className="text-bold mb-2 mt-5">Department</div>
          <p>
            1 Master node with 24 cores
          </p>
          <p>
          8 Compute nodes with 24 cores
          </p>
          <br />
        </div>
        <div className="col-sm-6 mt-4">
          <img
            src=" "
            className="img-responsive img-thumbnail"
          />
        </div>
      </div>
    </div>
  );
};

export default Resources;
